/* src/app/header/header-search/header-search.component.scss */
:host {
  display: block;
  min-width: 520px;
  position: relative;
}
:host ::ng-deep app-mb-field > div {
  margin: 0;
}
.search-results {
  position: absolute;
  z-index: 10000;
  top: calc(100% + 0.5rem);
  left: 0;
  width: 100%;
  max-height: 320px;
  overflow: auto;
  border: 1px solid #d3dde9;
  border-radius: 0.75rem;
  background: #fff;
  box-shadow: 0 10px 24px rgba(25, 42, 70, 0.12);
  padding: 0.5rem;
}
.result-group + .result-group {
  border-top: 1px solid rgba(94, 110, 130, 0.15);
  margin-top: 0.5rem;
  padding-top: 0.5rem;
}
.result-group h6 {
  margin: 0.15rem 0.5rem 0.35rem 0.5rem;
  font-size: 1.2rem;
  font-weight: 700;
  color: rgba(94, 110, 130, 0.9);
}
.result-group ul {
  margin: 0;
  padding: 0;
  list-style: none;
}
.result-group button {
  width: 100%;
  text-align: left;
  border: 0;
  background: transparent;
  padding: 0.65rem 0.75rem;
  border-radius: 0.5rem;
  color: rgb(94, 110, 130);
  font-size: 1.35rem;
}
.result-group button:hover {
  cursor: pointer;
  background: rgba(235, 241, 248, 0.85);
}
.search-results.empty {
  padding: 0.85rem 1rem;
}
.search-results.empty p {
  margin: 0;
  font-size: 1.3rem;
  color: rgba(94, 110, 130, 0.75);
}
@media (max-width: 1100px) {
  :host {
    min-width: 380px;
  }
}
@media (max-width: 900px) {
  :host {
    min-width: 240px;
  }
}
/*# sourceMappingURL=header-search.component.css.map */
